import { createStyles, Grid, makeStyles, Theme } from '@material-ui/core';
import React, { FC } from 'react';

import AccountManagement from '../features/account-management/AccountManagement';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
  }),
);

//Just a barebones implementation of the account settings page. This will be moved into the account pages once those components get set up.
const Settings: FC = () => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container spacing={3} direction="row" justify="center" alignItems="flex-start">
      <Grid item xs={12} lg={10}>
        <AccountManagement />
      </Grid>
    </Grid>
  );
};

export default Settings;
